// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as PorterStoreIcons from "./PorterStoreIcons.bs.js";

function PorterStoreToast(Props) {
  var toastType = Props.toastType;
  var message = Props.message;
  var visible = Props.visible;
  return React.createElement("div", {
              className: visible ? "ps-toast ps-toast--visible" : "ps-toast"
            }, React.createElement("div", {
                  className: "ps-toast__icon"
                }, toastType ? React.createElement(PorterStoreIcons.ToastError.make, {}) : React.createElement(PorterStoreIcons.ToastSuccess.make, {})), React.createElement("span", {
                  className: "ps-toast__message"
                }, message));
}

var make = PorterStoreToast;

export {
  make ,
  
}
/* react Not a pure module */
